import axios from "axios";

const DEFAULT_BASE_URL_V1 = "https://api.inbot.com.br/user-manager/v1";
const DEFAULT_BASE_URL_V2 = "https://api.inbot.com.br/v2/api";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || DEFAULT_BASE_URL_V1,
});

export const apiTemplateWhatsapp = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_V2 || DEFAULT_BASE_URL_V2,
});

export const getApiWithBaseUrl = (customBaseUrl: string | null) => {
  if (!customBaseUrl) {
    return api;
  }

  return axios.create({
    baseURL: customBaseUrl,
  });
};

export const getApiV2WithBaseUrl = (customBaseUrl: string | null) => {
  // Só usa URL customizada se for explicitamente uma URL v2
  if (customBaseUrl && customBaseUrl.includes("/v2/api")) {
    return axios.create({
      baseURL: customBaseUrl.endsWith("/v2/api")
        ? customBaseUrl
        : `${customBaseUrl}/v2/api`,
    });
  }

  // Caso contrário, usa a URL padrão do environment
  return apiTemplateWhatsapp;
};

export default api;
